import { createSelector } from 'reselect';

// selectors
const getLineScore = (state) => state.linescore;
const getLoading = (state) => state.loading?.isLoading;

// reselect function
export const getLineScoreState = createSelector(
    [getLineScore, getLoading],
    (linescore, isLoading) => (
        {
            ...linescore,
            isLoading
        }
    )
);
